import React from "react";
import moment from "moment";
import "./ControlCProductosDiseno.css"

class HistorialComprasPopover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            historial: [],
            cargando: false,
            error: null,
            popoverAbierto: false,
            popoverStyle: {}
        };
        
        this.togglePopover = this.togglePopover.bind(this);
        this.obtenerHistorial = this.obtenerHistorial.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.popoverRef = React.createRef();
        this.buttonRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('resize', this.handleResize);
        if (this.timeout) clearTimeout(this.timeout);
    }

    componentDidUpdate(prevProps, prevState) {

        if (!prevState.popoverAbierto && this.state.popoverAbierto && this.buttonRef.current) {
            this.calcularPosicionPopover();
        }
    }

    calcularPosicionPopover() {
        if (!this.buttonRef.current || !this.popoverRef.current) return;

        const buttonRect = this.buttonRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        
        const popoverElement = this.popoverRef.current;
        const popoverHeight = popoverElement.offsetHeight || 400;
        const popoverWidth = popoverElement.offsetWidth || 450;
        
        let top = buttonRect.top + window.scrollY;
        let left = buttonRect.right + 10;
        
        if (left + popoverWidth > viewportWidth) {
            left = buttonRect.left - popoverWidth - 10;
        }
        
        if (top + popoverHeight > viewportHeight + window.scrollY) {
            top = viewportHeight + window.scrollY - popoverHeight - 10;
        }
        
        if (top < window.scrollY) {
            top = window.scrollY + 10;
        }
        
        const arrowStyle = left < buttonRect.left ? { left: 'calc(100% - 10px)', right: 'auto' } : { left: '-10px' };

        this.setState({
            popoverStyle: {
                position: 'fixed',
                top: `${top}px`,
                left: `${left}px`,
                zIndex: 9999
            },
            arrowStyle
        });
    }

    handleResize = () => {
        if (this.state.popoverAbierto) {
            this.calcularPosicionPopover();
        }
    }

    handleClickOutside(event) {
        if (this.state.popoverAbierto && 
            this.popoverRef.current && 
            !this.popoverRef.current.contains(event.target) &&
            this.buttonRef.current &&
            !this.buttonRef.current.contains(event.target)) {
            this.setState({ popoverAbierto: false });
        }
    }

    togglePopover(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const { productoId, onToggle } = this.props;
        const { popoverAbierto } = this.state;
        
        const nuevoEstado = !popoverAbierto;
        this.setState({ popoverAbierto: nuevoEstado });
        
        if (onToggle) {
            onToggle(productoId, nuevoEstado);
        }
        
        if (nuevoEstado && !this.state.historial.length && !this.state.cargando) {
            this.obtenerHistorial();
        }
    }

    async obtenerHistorial() {
        const { productoId, servicioHistorial } = this.props;
        
        if (!productoId || !servicioHistorial) {
            this.setState({ error: 'Configuración incompleta' });
            return;
        }

        try {
            this.setState({ cargando: true, error: null });
            
            const historial = await servicioHistorial.obtenerHistorialComprasProducto(productoId);
            
            const ultimasCompras = historial ? historial.slice(0, 3) : [];
            
            this.setState({ 
                historial: ultimasCompras, 
                cargando: false 
            });
            
        } catch (error) {
            console.error('Error obteniendo historial:', error);
            this.setState({ 
                error: 'Error al cargar el historial', 
                cargando: false 
            });
        }
    }

    calcularPromedios() {
        const { historial } = this.state;
        
        if (!historial.length) return { cantidad: 0, precio: 0, total: 0 };
        
        const totalCantidad = historial.reduce((sum, item) => sum + parseFloat(item.Cantidad || 0), 0);
        const totalPrecio = historial.reduce((sum, item) => sum + parseFloat(item.PrecioUnitario || 0), 0);
        const totalLinea = historial.reduce((sum, item) => sum + parseFloat(item.TotalLinea || 0), 0);
        
        return {
            cantidad: totalCantidad / historial.length,
            precio: totalPrecio / historial.length,
            total: totalLinea / historial.length
        };
    }

    renderContent() {
        const { historial, cargando, error } = this.state;
        const { productoCodigo, productoNombre } = this.props;
        const promedios = this.calcularPromedios();

        if (cargando) {
            return (
                <div className="text-center py-4">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <p className="mt-2 mb-0 text-muted small">Cargando historial...</p>
                </div>
            );
        }

        if (error) {
            return (
                <div className="alert alert-danger m-3">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {error}
                </div>
            );
        }

        if (!historial.length) {
            return (
                <div className="alert alert-info m-3">
                    <i className="fas fa-info-circle me-2"></i>
                    No se encontraron compras registradas.
                </div>
            );
        }

        return (
            <div className="popover-content p-0">
                <div className="popover-header text-white border-0">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 className="mb-0">
                                <i className="fas fa-history me-2"></i>
                                Últimas Compras
                            </h6>
                            <small className="opacity-75">{productoCodigo} - {productoNombre}</small>
                        </div>
                        <button 
                            type="button" 
                            className="btn btn-sm btn-outline-light"
                            onClick={() => this.setState({ popoverAbierto: false })}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                
                <div className="table-responsive" style={{ maxHeight: '300px' }}>
                    <table className="table table-sm table-hover mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: '30%' }}>Proveedor</th>
                                <th style={{ width: '30%' }}>Documento</th>
                                <th style={{ width: '15%' }}>Fecha</th>
                                <th style={{ width: '15%' }}>Cantidad</th>
                                <th style={{ width: '20%' }}>Precio</th>
                                <th style={{ width: '20%' }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historial.map((compra, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="font-weight-bold">{compra.RazonSocialProveedor || 'N/A'}</div>
                                    </td>
                                    <td>
                                        <div className="small text-muted">{compra.NumeroMovimiento || 'N/A'}</div>
                                        <div className="font-weight-bold">{compra.NroDocumentoSunat || 'Sin Documento'}</div>
                                    </td>
                                    <td>
                                        <div className="font-weight-bold">
                                            {compra.FechaMovimiento ? moment(compra.FechaMovimiento).format('DD/MM') : 'N/A'}
                                        </div>
                                        <div className="small text-muted">
                                            {compra.FechaMovimiento ? moment(compra.FechaMovimiento).format('HH:mm') : ''}
                                        </div>
                                    </td>
                                    <td className="text-center">
                            
                                            {parseFloat(compra.Cantidad || 0).toFixed(2)}
       
                                    </td>
                                    <td className="text-right font-weight-bold text-success">
                                     {parseFloat(compra.PrecioUnitario || 0).toFixed(2)}
                                    </td>
                                    <td className="text-right font-weight-bold text-primary">
                                        {parseFloat(compra.TotalLinea || 0).toFixed(2)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        const { popoverAbierto, popoverStyle, arrowStyle = { left: '-10px' } } = this.state;
        const { className = '', disabled = false } = this.props;

        return (
            <div className="historial-compras-popover d-inline-block">
                <button
                    ref={this.buttonRef}
                    className={`btn btn-sm ${popoverAbierto ? 'btn-warning' : 'btn-info'} ${className}`}
                    onClick={this.togglePopover}
                    disabled={disabled}
                    title="Ver últimas compras"
                    type="button"
                >
                    <i className="fas fa-history"></i>
                </button>
                
                {popoverAbierto && (
                    <div 
                        ref={this.popoverRef}
                        className="popover-custom shadow-lg border-0"
                        style={popoverStyle}
                    >
                        <div className="popover show border-0">
                            <div className="popover-arrow" style={arrowStyle}></div>
                            {this.renderContent()}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default HistorialComprasPopover;